<template>
  <div class="cover">
    <div @click="openModal">
      <slot></slot>
    </div>

    <Modal :is-modal-active="isModalVisible || active" @close="closeModal">
      <template #title>
        {{ $t(isSetCookies ? "cookies.seting.title" : "cookies.title") }}
      </template>

      <div v-if="isSetCookies">
        <div v-for="(item, i) in content" :key="i">
          <Checkbox :disabled="item.disabled" :model-value="true">
            <h3>{{ item.title }}</h3>
          </Checkbox>
          <p class="info">{{ item.text }}</p>
        </div>
        <div class="buttons">
          <RippleButton class="button" type="prime" @click="acceptCookies">
            {{ $t("cookies.seting.button") }}
          </RippleButton>
        </div>
      </div>

      <div v-else>
        <p class="policy">
          {{ $t("cookies.text") }}
          <a href="/cookie_policy">{{ $t("cookies.link") }}</a>
        </p>
        <div class="buttons">
          <RippleButton class="button" type="prime" @click="acceptCookies">
            {{ $t("cookies.accept") }}
          </RippleButton>
          <RippleButton
            class="button"
            type="simple"
            @click="() => (isSetCookies = true)"
          >
            {{ $t("cookies.set") }}
          </RippleButton>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import RippleButton from "../common/form/Button.vue";
import Modal from "./Modal.vue";
import Checkbox from "../common/form/Checkbox.vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

const { locale, messages } = useI18n();
const content = computed(() => {
  const currentLocale = locale.value;
  const localeMessages = messages.value?.[currentLocale];
  return localeMessages?.cookies?.seting?.items || [];
});

const COOKIE_CONSENT_KEY = "cookie_consent_accepted";
const route = useRoute();

const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
});

const checkCookieConsent = () => {
  if (window.location.pathname == "/cookie_policy") {
    closeModal();
    return;
  }

  const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
  if (consent === "true") {
    closeModal();
  } else {
    openModal();
  }
};

const isModalVisible = ref(false);
const isSetCookies = ref(false);

function openModal() {
  isModalVisible.value = true;
}

function closeModal() {
  isModalVisible.value = false;
}

const acceptCookies = () => {
  localStorage.setItem(COOKIE_CONSENT_KEY, "true");
  closeModal();
};

watch(
  () => route.path,
  () => {
    checkCookieConsent();
  },
);

onMounted(() => {
  checkCookieConsent();
});
</script>
<style lang="scss" scoped>
a {
  color: var(--brand-color);
  text-decoration: underline;
}
.cover {
  overflow-y: auto;
  overflow-x: hidden;
}
.info {
  padding-left: 40px;
}
.policy {
  margin-bottom: 15px;
}
.button {
  width: 250px;
  height: 60px;
}
.buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}
</style>
